import React, { useEffect, useState } from 'react';
import { FormHelperText } from '@mui/material';

interface TimerProps {
  timerStartValue: number;
  timerExpireCallback: () => void;
  text?: string;
}

const Timer: React.FC<TimerProps> = ({
  timerStartValue,
  timerExpireCallback,
  text = 'Resend OTP'
}) => {
  const [timer, setTimer] = useState<number>(timerStartValue);

  useEffect(() => {
    let countdown: number;
    if (timer > 0) {
      countdown = window.setInterval(() => {
        setTimer(prevTimer => prevTimer - 1);
      }, 1000);
    } else {
      timerExpireCallback();
    }
    return () => clearInterval(countdown);
  }, [timer, timerExpireCallback]);

  return (
    <FormHelperText>
      {text} in {timer} seconds
    </FormHelperText>
  );
};

export default Timer;
